module.exports = __webpack_public_path__ + "img/favicon.5fa6af4.png";